import { render, staticRenderFns } from "./ServiceLightGiveway.vue?vue&type=template&id=4849b52d"
import script from "./ServiceLightGiveway.vue?vue&type=script&scoped=true&lang=js"
export * from "./ServiceLightGiveway.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./ServiceLightGiveway.vue?vue&type=style&index=0&id=4849b52d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports